import { render, staticRenderFns } from "./prepare.vue?vue&type=template&id=621afa10&scoped=true"
import script from "./prepare.vue?vue&type=script&lang=js"
export * from "./prepare.vue?vue&type=script&lang=js"
import style0 from "./prepare.vue?vue&type=style&index=0&id=621afa10&scoped=true&lang=scss"
import style1 from "./prepare.vue?vue&type=style&index=1&id=621afa10&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "621afa10",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/frontend_coduck_business_lcPT/node_modules/_vue-hot-reload-api@2.3.4@vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('621afa10')) {
      api.createRecord('621afa10', component.options)
    } else {
      api.reload('621afa10', component.options)
    }
    module.hot.accept("./prepare.vue?vue&type=template&id=621afa10&scoped=true", function () {
      api.rerender('621afa10', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/ScratchJr/prepare.vue"
export default component.exports